module.exports = __webpack_public_path__ + "img/csm__MG_8701_14eb235cc5.3499550e.jpg";